module.exports = __webpack_public_path__ + "static/media/main.8b336ed3.png";